/**
 * Function to validate japanese mobile phone number by considering:
 * (1) 11-digit input check of the phone number: Whether the entered phone number is 11 digits
 * (2) Phone number input format check: Check if the entered phone number is in the following format:
 *      I.) 1st digit is 0
 *      II.) 2nd digit is 5~9
 *      III.) 3rd digit is 0
 *       Any number after digits 4~11
 */
export const isValidJapaneseMobileNo = (mobileNo: string): boolean => {
  const pattern = /^[0][5-9][0]\d{8}$/;
  return pattern.test(mobileNo);
};
